import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import ProgessTitle from '../components/ProgessTitle';
import Sponsors from '../components/Sponsors';
import '../assets/styles/containers/CheckRegisterInfo.sass';

const CheckRegisterInfo = (props) => {
  const [info, setInfo] = useState([]);
  const [pricing, setPricing] = useState([]);

  const handleGoBack = () => {
    props.history.goBack();
  }

  const handlePay = () => {
    window.location.href = "/adventures/confirmation-page";
  }

  const getBanner = () => {
    switch (info.tour) {
      case 'coffee':
        return <Banner id={60} city="coffee" lineBottom={'line'} thumb="logo_adventures.png"/>;
      case 'volcano':
        return <Banner id={61} city="volcano" lineBottom={'line'} thumb="logo_adventures.png"/>;
      case 'antioquia':
        return <Banner id={64} city="antioquia" lineBottom={'line'} thumb="logo_adventures.png"/>;
      default:
        return <Banner id={60} city="coffee" lineBottom={'line'} thumb="logo_adventures.png"/>;
    }
  }

  useEffect(() => {
    const session = sessionStorage.getItem('la-leyenda-adventures');
    const data = JSON.parse(session);
    setInfo(data);

    const price = sessionStorage.getItem('lldd-adventures-pricing');
    const priceFormat = JSON.parse(price);
    const priceSelected = priceFormat.filter(item => item.value === data.date);
    setPricing(...priceSelected);
  }, []);

  return (
    <Layout>
      {getBanner()}
      <ProgessTitle
        step2="active"
        tour={info.tour}
      />
      <div className="row CheckRegisterInfo">
        <div className="container">
          <div className="row">
            <div className="col-12">

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Fecha</dt>
                <dd class="col-sm-5">{pricing ? ReactHtmlParser(pricing.content_es) : ''}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Nombres</dt>
                <dd class="col-sm-5">{info.name}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Apellidos</dt>
                <dd class="col-sm-5">{info.surname}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Correo electrónico</dt>
                <dd class="col-sm-5">{info.email}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Teléfono</dt>
                <dd class="col-sm-5">{info.phone}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de documento</dt>
                <dd class="col-sm-5">{info.type_id}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Documento No.</dt>
                <dd class="col-sm-5">{info.number}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de sangre</dt>
                <dd class="col-sm-5">{info.blood_group}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Proveedor de seguro médico / EPS</dt>
                <dd class="col-sm-5">{info.eps}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Nacionalidad</dt>
                <dd class="col-sm-5">{info.nacionality}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Sexo</dt>
                <dd class="col-sm-5">{info.sex}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Fecha de nacimiento</dt>
                <dd class="col-sm-5">{info.birthday_day} / {info.birthday_month} / {info.birthday_year}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Dirección</dt>
                <dd class="col-sm-5">{info.address}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Ciudad</dt>
                <dd class="col-sm-5">{info.city}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">País</dt>
                <dd class="col-sm-5">{info.country}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Acudiente en caso de emergencia</dt>
                <dd class="col-sm-5">{info.emergency_contact_name}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Teléfono acudiente con código de área</dt>
                <dd class="col-sm-5">{info.emergency_contact_number}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Talla de Jersey (Específico de género)</dt>
                <dd class="col-sm-5">{info.jersey_size}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Talla de camiseta (Específico de género)</dt>
                <dd class="col-sm-5">{info.t_shirt_size}</dd>
              </dl>

              {info.instagram &&
                <dl class="row mb-0 justify-content-center">
                  <dt class="col-sm-4">Usuario Instagram</dt>
                  <dd class="col-sm-5">{info.instagram}</dd>
                </dl>
              }

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">¿Cómo supiste sobre La Leyenda?</dt>
                <dd class="col-sm-5">{info.know}</dd>
              </dl>

              {info.medical_conditions &&
                <dl class="row mb-0 justify-content-center">
                  <dt class="col-sm-4">¿Tiene alguna condición médica, alergias o requerimientos dietéticos especiales que debemos tener en cuenta?</dt>
                  <dd class="col-sm-5">{info.medical_conditions}</dd>
                </dl>
              }

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de bicicleta</dt>
                <dd class="col-sm-5">{info.type_of_bike}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Marca de bicicleta</dt>
                <dd class="col-sm-5">{info.make_of_bike}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de transmisión</dt>
                <dd class="col-sm-5">{info.chainset}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tamaño de rin</dt>
                <dd class="col-sm-5">{info.wheel_size}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Número de velocidades</dt>
                <dd class="col-sm-5">{info.number_of_speeds}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Marca de frenos</dt>
                <dd class="col-sm-5">{info.make_of_brakes}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Transmisión</dt>
                <dd class="col-sm-5">{info.drivetrain}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Método de pago</dt>
                <dd class="col-sm-5">{info.payment}</dd>
              </dl>

              <div class="my-4"></div>

              <div class="row mb-4">
                <div class="col text-right">

                  <div className="row">
                    <div className="col-12 CheckRegisterInfo-buttons">
                      <button type="button" className={`btn btn-ll --${info.tour}`} onClick={() => handleGoBack()}>ATRAS</button>
                      <button type="submit" className={`btn btn-ll --${info.tour}`} onClick={() => handlePay()}>CONTINUAR</button>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Sponsors
        items={[]}
        city={info.tour}
      />
    </Layout>
  );
};

export default CheckRegisterInfo;
